import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { bucketApi, type DeleteModelPhotoInput } from '~/supabase/bucket/api'

export const useDeleteModelPhoto = () => {
  return useMutation({
    mutationKey: ['delete-model-photo'],
    mutationFn: (input: DeleteModelPhotoInput) => bucketApi.deleteModelPhoto(input),
    onSuccess: () => {
      toast.success('Photo deleted successfully')
    },
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
}
